import script from "./Scalebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Scalebar.vue?vue&type=script&setup=true&lang=ts"

import "./Scalebar.vue?vue&type=style&index=0&id=6b9ed66c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9ed66c"]])

export default __exports__